import { paths } from "src/pages/paths";

// API
// ----------------------------------------------------------------------

export const HOST_API = import.meta.env.VITE_HOST_API;
export const DOMAIN_ADDRESS = import.meta.env.VITE_DOMAIN_ADDRESS;
export const SENTRY_KEY = import.meta.env.VITE_SENTRY_KEY;
export const STRIPE_KEY = import.meta.env.VITE_STRIPE_KEY;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.dashboard.root; // as '/dashboard'
export const PAGE_SIZE = 20; // as '/dashboard'
export const VERSION = 10.5; //
